//Strings
import { Strings } from "../../resources/i18n/i18n";

// Decisions the approver can take on a request.
export const ENTRY_LEVEL_STATUS = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

// MC-5742: entry level request state of a minimart, received as
// entryLevelRequestStatus.
export const ENTRY_LEVEL_REQUEST_STATUS = {
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

// MC-5742: every state a request can be listed in. A rejection is recorded rather
// than deleting the customer, so rejected requests stay on the worklist too.
// SearchFilter builds each option's value from a `||` chain, so an empty value
// is dropped and the browser reports the option's label instead. "All" therefore
// needs a non-empty sentinel; it is stripped before the request is sent.
export const ENTRY_LEVEL_STATUS_ALL = "ALL";

// MC-5742: same sentinel treatment for the seller dropdown, whose first entry is
// a placeholder standing for "every seller".
export const SELLER_FILTER_ALL = "ALL";

export const ENTRY_LEVEL_STATUS_FILTER_OPTIONS = [
  { value: ENTRY_LEVEL_STATUS_ALL, label: Strings("All") },
  {
    value: ENTRY_LEVEL_REQUEST_STATUS.PENDING_APPROVAL,
    label: Strings("PENDING_APPROVAL"),
  },
  {
    value: ENTRY_LEVEL_REQUEST_STATUS.APPROVED,
    label: Strings("APPROVED_ENTRY_LEVEL"),
  },
  {
    value: ENTRY_LEVEL_REQUEST_STATUS.REJECTED,
    label: Strings("REJECTED_ENTRY_LEVEL"),
  },
];

// MC-5796: a request raised against an already-approved minimart came from the
// prospect screen rather than from a registration, and the row is called out as such.
export const PROSPECT_REGISTRATION_STATUS = "APPROVED";

// MC-5742: entry level requests report, served by
// ReportDownloadController#downloadEntryLevelRequestsReport under /reports.
export const ENTRY_LEVEL_REPORT_DOWNLOAD = {
  downloadUrl: "/entry-level/download",
};

// First row shown for every request - kept short so the list stays scannable.
export const FIRST_ROW_COLUMNS = [
  { key: "name", name: "MiniMartname" },
  { key: "sellerName", name: "sellerName" },
  { key: "createdAt", name: "creationDate", format: "date" },
  { key: "eligibleLoanType", name: "requestedLevel" },
  // Who approved it and when are only filled once the request has been decided,
  // so they live in the expanded APPROVAL_DETAILS_COLUMNS section rather than
  // reading NA here on every pending row.
  { key: "action", name: "action" },
];

// MC-5742: the rest of the minimart's details, shown when a row is expanded.
// Rows are EntryLevelRequestDto, built for this screen by a single projection
// query, so these are the only minimart fields available here.
export const SECOND_ROW_COLUMNS = [
  { key: "sellerName", name: "sellerName" },
  { key: "ownerName", name: "ownerName" },
  { key: "cedulaId", name: "ownerCedulaNumber" },
  { key: "telephone", name: "PhoneNumber" },
  { key: "ownerNumber", name: "MobileNumberOfOwner" },
  { key: "city", name: "City" },
  { key: "sector", name: "Sector" },
  { key: "street", name: "Street" },
  { key: "number", name: "number" },
  { key: "reference", name: "Reference" },
  { key: "branch", name: "associatedBranch" },
  { key: "zone", name: "associatedZone" },
  { key: "messengerZone", name: "associatedMessengerZone" },
  { key: "businessType", name: "businessType" },
  { key: "registrationStatus", name: "registrationStatus" },
  // The minimart's own collection days are deliberately left out: the backend
  // fills that field from m.collectionCycle, which is unset on a registration
  // this new, and the days the customer actually asked for are shown with the
  // loan below.
];

// MC-5742: shown once the request has been decided either way - who decided and
// when, read back from the audit trail by the backend, plus the reason the
// approver gave, read back from the note saved against the requested loan. The
// backend keeps the approvedBy/approvedAt field names for both decisions.
export const DECISION_DETAILS_COLUMNS = [
  { key: "approvedBy", name: "decidedBySalesManager" },
  { key: "approvedAt", name: "decisionDate", format: "date" },
];

// MC-5742: details of the loan the customer requested at this level, nested
// under request.requestedLoanInfo.
export const LOAN_DETAILS_COLUMNS = [
  { key: "type", name: "loanType" },
  { key: "amountRequested", name: "amountRequested", format: "currency" },
  { key: "termRequested", name: "termRequested" },
  { key: "interestRate", name: "interestRate" },
  { key: "emi", name: "emi", format: "currency" },
  { key: "frequency", name: "frequency" },
  { key: "collectionDays", name: "collectionDays", format: "days" },
];
